import { createAction } from './actions.js'

export const HYDRATE_STATE = 'HYDRATE_STATE'
export const hydrateState = createAction(HYDRATE_STATE)

export function makeHydratable (reducer, hydrateActionType) {
  return function (state, action) {
    switch (action.type) {
      case hydrateActionType:
        return reducer(action.payload, action)
      default:
        return reducer(state, action)
    }
  }
}



// WEBPACK FOOTER //
// ./client/src/util/stateHydration.js